import React, { useState } from "react";
import { Dialog, DialogContent, Button, IconButton } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

const MobileActionCardOverlay = ({
  actionCard,
  onSelect,
  canPlay,
  isSelected,
}) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSelect = () => {
    if (onSelect && canPlay) {
      onSelect(actionCard);
      handleClose();
    }
  };

  return (
    <>
      {/* Tap target - full card area */}
      <div
        onClick={handleOpen}
        className="mobile-action-card-overlay-trigger"
      />

      {/* Mobile Menu Dialog */}
      <Dialog
        open={open}
        onClose={handleClose}
        PaperProps={{
          className: "mobile-overlay-dialog"
        }}
      >
        <DialogContent className="p-0">
          {/* Header */}
          <div className="mobile-overlay-header">
            <h3 className="mobile-overlay-header-title">
              {actionCard.displayValue || actionCard.name}
            </h3>
            <IconButton
              onClick={handleClose}
              size="small"
              className="p-xs"
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </div>

          {/* Content */}
          <div className="p-md flex flex-col gap-md">
            {/* Description */}
            {actionCard.description && (
              <div className="text-base leading-relaxed text-primary font-italic p-md bg-gray-50 rounded-md">
                {actionCard.description}
              </div>
            )}

            {/* Action Type Info */}
            <div className="text-sm text-secondary">
              <div className="font-bold mb-sm">Action Type:</div>
              <div>{actionCard.actionType}</div>
            </div>

            {/* Effect Value if applicable */}
            {(actionCard.effectValue !== undefined && actionCard.effectValue !== null) && (
              <div className="text-sm text-secondary">
                <div className="font-bold mb-sm">Effect:</div>
                <div className={`text-lg font-bold ${actionCard.effectValue > 0 ? 'text-green-500' : 'text-red-500'}`}>
                  {actionCard.effectValue > 0 ? '+' : ''}{actionCard.effectValue}
                </div>
              </div>
            )}

            {/* Divider */}
            <div className="mobile-overlay-divider" />

            {/* Select Button */}
            <Button
              onClick={handleSelect}
              disabled={!canPlay}
              fullWidth
              variant="contained"
              className={`mobile-overlay-button ${canPlay ? 'mobile-overlay-button-buy' : 'mobile-overlay-button-disabled'}`}
            >
              {isSelected ? '✓ SELECTED' : 'SELECT CARD'}
            </Button>

            {/* Cancel Button */}
            <Button
              onClick={handleClose}
              fullWidth
              variant="text"
              className="mobile-overlay-button-text"
            >
              CANCEL
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default MobileActionCardOverlay;

